import {
    Button,
    Grid,
    Typography,
    useTheme,
} from "@valenzinsights/core-component";
import { ErrorGroupIconSvg, ValenzLogoIconSvg } from "@valenzinsights/images";

import { useNavigate } from "react-router-dom";

export const Error404 = () => {
	const theme = useTheme();
	const navigate = useNavigate();
	const classes = {
		root: {
			backgroundColor: theme.palette.common.white,
			display: "flex",
			width: "100%",
			// overflowX: "hidden",
		},
		footer: {
			height: "5%",
			display: "grid",
			justifyContent: "center",
			alignContent: "center",
		},

		message: {
			fontSize: "32px !important",
			marginBottom: "10px !important",
			fontWeight: "600 !important",
		},
		content: {
			alignItems: "center",
			display: "flex",
		},
		contentImage: {
			display: "flex",
			height: "95%",
			alignItems: "center",
			justifyItems: "center",
		},
		contentContainer: {
			border: "1 solid black",
			display: "grid",
			paddingLeft: "15%",
			justifyContent: "center",
			alignContent: "center",
		},
		errorLogo: {
			width: "100%",
			height: "calc(100vh - 83px)",
			[theme.breakpoints.between("xs", "sm")]: {
				width: "100%",
				margin: "0 auto",
			},
		},
		link: {
			marginTop: "20px !important",
		},
		appLogo: {
			width: "300px",
			[theme.breakpoints.between("xs", "sm")]: {
				width: "300px",
				margin: "auto auto",
			},
		},
	};

	return (
		<div style={classes.root}>
			<Grid container>
				<Grid item sm={12} xs={12} md={12} xl={12} lg={12} style={classes.content}>
					<div style={{ position: "relative", width: "100%" }}>
						<div
							style={{
								position: "absolute",
								width: "100%",
								textAlign: "center",
								top: "0px",
							}}
						>
							<img style={{ width: "200px" }} src={ValenzLogoIconSvg} alt="" />
						</div>
						<img style={classes.errorLogo} src={ErrorGroupIconSvg} />
						<div
							style={{
								position: "absolute",
								top: "0",
								display: "flex",
								flexDirection: "column",
								height: "100%",
								justifyContent: "center",
								paddingLeft: "150px",
							}}
						>
							<div style={{ fontSize: "40px", fontWeight: "bold" }}>404</div>
							<div style={{ fontSize: "24px", fontWeight: "bold" }}>Oops !</div>
							<Typography style={classes.message}>Page Not Found</Typography>
							<div>This page doesn't exsist or was removed!</div>
							<div style={{ marginBottom: "10px" }}>We suggest you go back home</div>
							<div>
								<Button onClick={() => navigate("/")} variant="contained">
									Home
								</Button>
							</div>
						</div>
					</div>
				</Grid>
			</Grid>
		</div>
	);
};
